import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ecc314b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/auth.scss?vue&type=style&index=0&id=1ecc314b&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=1ecc314b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc314b",
  null
  
)

export default component.exports